import { Button, Grid, IconButton } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import PDialog from "../../components/pos/PDialog";
import db from "../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useState } from "react";
import readXlsxFile from "read-excel-file";
import API from "../../utils/API";
import { PricingUtils } from "../../utils/PricingUtils";
import { Store } from "../../utils/Store";
import ImportProgress from "./ImportProgress";

export default function ProductImport(props) {
  const [showImport, setShowImport] = useState(false);
  const [data, setData] = useState([]);
  const [alertFlag, setAlertFlag] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [vendorData, setVendorData] = useState([]);

  const [disableLoading, setDisableLoading] = useState(false);
  const [disableImport, setDisableImport] = useState(true);
  const [importing, setImporting] = useState(false);
  const [loading, setLoading] = useState(false);

  const [vendorStat, setVendorStat] = useState("");
  const [vendorPer, setVendorPer] = useState(0);

  const [failedVendors, setFailedVendors] = useState("");
  const [successVendors, setSuccessVendors] = useState("");

  const [catPer, setCatPer] = useState(0);
  const [failedCat, setFailedCat] = useState("");
  const [successCat, setSuccessCat] = useState("");
  const [catStat, setCatStat] = useState("");

  const [prodAnalysingPer, setProdAnalysingPer] = useState(0);
  const [prodAnalysingStat, setProdAnalysingStat] = useState("");

  const [analyseResult1, setAnalyseResult1] = useState("");
  const [analyseResult2, setAnalyseResult2] = useState("");

  const [prodPer, setProdPer] = useState(0);
  const [failedProd, setFailedProd] = useState("");
  const [successProd, setSuccessProd] = useState("");
  const [prodStat, setProdStat] = useState("");

  const [dataTableTitle, setDataTableTitle] = useState("Import Product");
  const [options, setOptions] = useState(getDefaultOptions());
  const [columns, setColumns] = useState(getDefaultColumns());

  function getDefaultOptions() {
    return {
      filter: false,
      download: true,
      print: false,
      selectableRows: "none",
    };
  }

  function getDefaultColumns() {
    return [
      {
        name: "Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Code",
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: "Short Name",
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
      {
        name: "Local Name",
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
      {
        name: "Vendor",
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: "Department",
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: "Sub Department",
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
      {
        name: "Tax",
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
      {
        name: "Deli EOM",
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
      {
        name: "Unit Type",
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
      {
        name: "Factor",
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
      {
        name: "Cost",
        options: {
          filter: false,
          sort: false,
          display: true,
        },
      },
      {
        name: "Price",
        options: {
          filter: false,
          sort: false,
          display: true,
        },
      },
      {
        name: "Barcodes",
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
    ];
  }

  function getSummaryColumns() {
    return [
      {
        name: "Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Message",
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: "Details",
        options: {
          filter: false,
          sort: false,
        },
      },
    ];
  }

  function onCloseWindow() {
    props.windowCLoseHandler(false);
  }
  async function onSave() {
    setVendorStat("");
    setFailedVendors("");
    setVendorPer(0);
    setSuccessVendors("");
    setCatPer(0);
    setFailedCat("");
    setSuccessCat("");
    setCatStat("");
    setProdAnalysingPer(0);
    setProdAnalysingStat("");
    setAnalyseResult1("");
    setAnalyseResult2("");
    setProdPer(0);
    setFailedProd("");
    setSuccessProd("");
    setProdStat("");

    setDisableImport(true);
    setImporting(true);
    let vMap = {};
    let tMap = {};
    let pMap = {};

    let cMap = {};
    let skip = 0;
    let product = await db.product.toArray();
    for (let pr of product) {
      pMap[pr.name] = pr.id;
    }

    let vendors = await db.vendor.toArray();
    for (let v of vendors) {
      vMap[v.name] = v.id;
    }
    let taxes = await db.tax.toArray();
    for (let t of taxes) {
      tMap[t.rate] = t.id;
    }
    let categorys = await db.category.toArray();
    for (let c of categorys) {
      cMap[c.id] = { name: c.name, parentId: c.parentId };
    }
    let dt = [...data];
    setVendorStat("IN_PROGRESS");
    await new Promise((r) => setTimeout(r, 1));
    try {
      let totalV = dt.length;
      let total = dt.length;
      let processedV = 0;
      let vFail = 0;
      let vSuccess = 0;
      let prevPer = 0;
      if (vendorData) {
        let count = 0;
        totalV = total + vendorData.length + 1;

        for (let d of vendorData) {
          if (count > 0) {
            if (d[0] == null) break;
            if (vMap[d[0]]) {
              skip++;
            } else {
              let saveObject = {};
              saveObject["name"] = d[0];
              saveObject["id"] = null;
              saveObject["intVersion"] = 0;
              saveObject["openingAmount"] = 0;
              saveObject["code"] = d[1] ? d[1] : "AUTO";
              saveObject["contact1"] = d[3];
              saveObject["address1"] = d[4];
              saveObject["trnNo"] = d[2];
              saveObject["paymentMode"] = d[5];
              saveObject["paymentModeId"] = getPaymentModeId(d[5]);
              saveObject["openingBalance"] = "0";
              try {
                let result = await API.post("/api/v1/vendor", saveObject);
                vMap[d[0]] = result.data.id;
                vSuccess++;
              } catch (err) {
                vFail = vFail + 1;
              }
            }
          }
          processedV++;
          let per = Math.round((processedV / totalV) * 100);
          if (per >= prevPer + 5) {
            setVendorPer(per);
            await new Promise((r) => setTimeout(r, 10));
            prevPer = per;
          }
          count++;
        }
      }

      for (let d of dt) {
        if (d[0] == null) break;
        if (vMap[d[4]]) {
          skip++;
        } else {
          let saveObject = {};
          saveObject["name"] = d[4];
          saveObject["id"] = null;
          saveObject["intVersion"] = 0;
          saveObject["openingAmount"] = 0;
          saveObject["code"] = "AUTO";
          saveObject["contact1"] = "";
          saveObject["address1"] = "";
          saveObject["trnNo"] = "";
          saveObject["paymentMode"] = "CREDIT";
          saveObject["paymentModeId"] = 1;
          try {
            let result = await API.post("/api/v1/vendor", saveObject);
            vMap[d[4]] = result.data.id;
            vSuccess++;
          } catch (err) {
            vFail = vFail + 1;
          }
        }
        processedV++;
        let per = Math.round((processedV / totalV) * 100);
        if (per >= prevPer + 5) {
          setVendorPer(per);
          await new Promise((r) => setTimeout(r, 1));
          prevPer = per;
        }
      }

      setSuccessVendors(vSuccess + " Inserted");
      setFailedVendors(vFail + " Failed");
      setVendorStat("COMPLETED");
      await new Promise((r) => setTimeout(r, 1));

      for (let d of dt) {
        if (d[0] == null) break;
        let taxValue = d[7] + ".00";
        if ((d[7] + "").includes(".")) {
          taxValue = d[7] + "0";
        }

        if (!tMap[taxValue]) {
          let saveObject = {};
          saveObject["name"] = "VAT " + d[7] + " %";
          saveObject["rate"] = d[7];

          let result = await API.post("/api/v1/tax", saveObject);
          tMap[taxValue] = result.data.id;
        }
      }

      let totalCat = total + total;
      processedV = 0;
      vFail = 0;
      vSuccess = 0;
      prevPer = 0;
      setCatStat("IN_PROGRESS");
      await new Promise((r) => setTimeout(r, 1));

      for (let d of dt) {
        if (d[0] == null) break;

        if (isCategoryExist(cMap, null, d[5])) {
          skip = 0;
        } else {
          let saveObject = {};

          saveObject["name"] = d[5];
          saveObject["catCode"] = "AUTO";
          saveObject["level"] = 0;
          saveObject["groupCode"] = "";
          saveObject["promotionIds"] = [];
          try {
            let result = await API.post("/api/v1/category", saveObject);
            cMap[result.data.id] = { name: d[5], parentId: null };
            vSuccess++;
            setSuccessCat(vSuccess);
            await new Promise((r) => setTimeout(r, 1));
          } catch (err) {
            vFail = vFail + 1;
          }
        }
        processedV++;
        let per = Math.round((processedV / totalCat) * 100);
        if (per >= prevPer + 5) {
          setCatPer(per);
          await new Promise((r) => setTimeout(r, 1));
          prevPer = per;
        }
      }

      for (let d of dt) {
        if (d[0] == null) break;

        if (d[6]) {
          if (isCategoryExist(cMap, getCategory(cMap, null, d[5]), d[6])) {
            skip = 0;
          } else {
            let saveObject = {};

            saveObject["name"] = d[6];
            saveObject["catCode"] = "AUTO";
            saveObject["parentId"] = getCategory(cMap, null, d[5]);

            saveObject["level"] = 1;
            saveObject["groupCode"] = "";
            saveObject["promotionIds"] = [];

            console.log(d[5], saveObject);
            try {
              let result = await API.post("/api/v1/category", saveObject);
              cMap[result.data.id] = {
                name: d[6],
                parentId: saveObject["parentId"],
              };
              vSuccess++;
            } catch (err) {
              vFail = vFail + 1;
              console.log(cMap);
              console.log(err);
              //throw err;
            }
          }
        }
        processedV++;
        let per = Math.round((processedV / totalCat) * 100);
        if (per >= prevPer + 5) {
          setCatPer(per);
          await new Promise((r) => setTimeout(r, 1));
          prevPer = per;
        }
      }
      setSuccessCat(vSuccess + " Inserted");
      setFailedCat(vFail + " Failed");
      setCatStat("COMPLETED");
      setProdAnalysingStat("IN_PROGRESS");
      await new Promise((r) => setTimeout(r, 1));

      prevPer = 0;
      processedV = 0;
      let skippedProd = 0;
      let nprodToSave = 0;

      //PRODDUCT IMPORT
      let prodToSave = {};
      for (let d of dt) {
        if (d[0] == null) break;

        if (pMap[d[0]]) {
          skippedProd++;
          console.log("Skiping ", d[0]);
        } else {
          let taxValue = d[7] + ".00";

          if (prodToSave[d[0]]) {
            let bean = prodToSave[d[0]];
            updatePricing(bean, d);
          } else {
            let bean = {
              name: d[0],
              code: d[1] ? d[1] : "AUTO",
              deptId: getCategory(cMap, null, d[5]),
              subDeptId: getCategory(cMap, getCategory(cMap, null, d[5]), d[6]),
              catId: null,
              subCatId: null,
              vendorId: vMap[d[4]],
              taxId: tMap[taxValue],
              shortName: d[2],
              localName: d[3],
              uom: d[8],
              unitSymbol: "",
              currentStock: "0",
              isOpenPrice: false,
              isOpenQty: false,
              isDiscounted: false,
              includeTaxInPrice: true,
              includeDiscountInPrice: false,
              isFastItem: "",
              productPricingBeanList: [],
              productFiles: [],
              kitItems: [],
              isKit: false,
              isStockItem: true,
              isExpandKitDuringSale: false,
              productInfoField1: "",
              productInfoField2: "",
              id: null,
              intVersion: 0,
              productType: "I",
            };
            updatePricing(bean, d);

            prodToSave[d[0]] = bean;
            nprodToSave++;
          }

          //let result = await API.post("/api/v1/product", saveObject);
          //pMap[d[0]] = result.data.name;
        }
        processedV++;
        let per = Math.round((processedV / total) * 100);
        if (per >= prevPer + 5) {
          setProdAnalysingPer(per);
          await new Promise((r) => setTimeout(r, 1));
          prevPer = per;
        }
      }

      setProdAnalysingStat("COMPLETED");
      setAnalyseResult1("Number of Products already exist:" + skippedProd);
      setAnalyseResult2("Number of Products to be inserted:" + nprodToSave);
      setProdStat("IN_PROGRESS");
      await new Promise((r) => setTimeout(r, 1));

      prevPer = 0;
      processedV = 0;
      let res = { savedProd: 0, failedProd: 0 };

      let failedProdArr = [];
      let batch = [];
      let count = 0;

      for (let key in prodToSave) {
        if (count > 0 && count % 50 == 0) {
          await saveProduct(batch, failedProdArr, res);
          batch = [];
        }
        if (validate(product, prodToSave[key], failedProdArr, res)) {
          batch.push(prodToSave[key]);
          product.push(prodToSave[key]);
          count++;
        }
        processedV++;
        let per = Math.round((processedV / nprodToSave) * 100);
        if (per > prevPer) {
          setProdPer(per);
          await new Promise((r) => setTimeout(r, 1));
          prevPer = per;
        }
      }
      if (batch.length > 0) {
        await saveProduct(batch, failedProdArr, res);
      }
      if (processedV == 0) {
        setProdPer(100);
      } else {
        let per = Math.round((processedV / nprodToSave) * 100);
        if (per > prevPer) {
          setProdPer(per);
          await new Promise((r) => setTimeout(r, 1));
          prevPer = per;
        }
      }
      if (res.failedProd > 0) {
        setColumns(getSummaryColumns());
        setDataTableTitle("Import Failures");
        setData(failedProdArr);
        setDisableImport(true);
      } else {
        setDisableImport(false);
        setData([]);
      }
      setFailedProd(res.failedProd + " Failed");
      setSuccessProd(res.savedProd + " Inserted");
      setProdStat("COMPLETED");

      await new Promise((r) => setTimeout(r, 1));
    } catch (err) {
      setDisableImport(false);
      console.log(err);
    }
  }

  function validate(products, product, failedArray, res) {
    return true;
    for (let pr of product.productPricingBeanList) {
      for (let bCode of pr.productBarcodeBeanList) {
        if (bCode.barcode + "" == product.code + "") {
          failedArray.push([product.name, "failed", "Code Same As Barcode"]);
          res.failedProd++;
          return false;
        }
      }
    }
    for (let p of products) {
      if ((p.name + "").toUpperCase() == (product.name + "").toUpperCase()) {
        failedArray.push([product.name, "failed", "Duplicate Name"]);
        res.failedProd++;
        return false;
      }
      if ((p.code + "").toUpperCase() == (product.code + "").toUpperCase()) {
        failedArray.push([product.name, "failed", "Duplicate Code"]);
        res.failedProd++;
        return false;
      }
      for (let pr of p.productPricingBeanList) {
        for (let bCode of pr.productBarcodeBeanList) {
          if (product.code + "" == bCode.barcode + "") {
            failedArray.push([
              product.name,
              "failed",
              "Code Already Exist as Barcode",
            ]);
            res.failedProd++;
            return false;
          }

          for (let pp of product.productPricingBeanList) {
            for (let bbCodes of pp.productBarcodeBeanList) {
              if (bCode.barcode + "" == bbCodes.barcode + "") {
                res.failedProd++;
                failedArray.push([
                  product.name,
                  "failed",
                  "Barcode Already Exist",
                ]);
                return false;
              }
              if (p.code + "" == bbCodes.barcode + "") {
                failedArray.push([
                  product.name,
                  "failed",
                  "Code Already Exist as Barcode",
                ]);
                res.failedProd++;
                return false;
              }
            }
          }
        }
      }
    }

    //Check Name Duplicate - DOne
    //Check Code Duplicate - Done
    //COde Same as Barcode in current Product // DOne
    //Code used as Barcode or Not  // Done
    //Barcode Already Exist
    //Barcode already used as Code

    return true;
  }

  async function saveProduct(batch, failedProdArr, result) {
    try {
      let { data } = await API.post("/api/v1/create_batch", batch);
      for (let d of data) {
        if (d.status == "failed") {
          failedProdArr.push([d.name, d.status, d.description]);
          result["failedProd"] = result["failedProd"] + 1;
        }
      }
    } catch (err) {
      console.log("### Import Failed", err);
    }
  }

  function getPaymentModeId(paymentMode) {
    if (paymentMode === "CREDIT") return 1;
    if (paymentMode === "CASH") return 2;
    if (paymentMode === "BANK") return 3;
  }

  function updatePricing(bean, d) {
    let decimal = parseInt(Store.get("decimal"));
    let result = PricingUtils.derivePrice(
      decimal, //TODO dynamic decial
      d[11], //COst
      d[12], //Price
      true, //Inc tax
      d[7], //Tax Rate
      false, //Inc Promotion
      0, // Promotion Per
      null, //Promoton Amt
      false, //Is Discounted
      1,
      false
    );

    bean.productPricingBeanList.push({
      unitType: d[9],
      factor: d[10],
      cost: d[11],
      margin: result.netMargin == "NaN" ? 0 : result.netMargin,
      marginPer:
        result.marginPer == "NaN" || result.netMargin < 0
          ? 0
          : result.marginPer,
      position: 1,
      price: d[12],
      productBarcodeBeanList: getBarcodes(d[13]),
      promotionIds: [],
      pricingLevelBeanList: [],
    });
  }

  function getBarcodes(barcodes) {
    let arr = [];
    let count = 1;
    for (let bar of (barcodes + "").split(",")) {
      arr.push({ position: count, barcode: bar });
      count++;
    }
    return arr;
  }

  function getCategory(cMap, parent, name) {
    for (var key in cMap) {
      if (parent == undefined) {
        if (cMap[key].parentId == undefined && cMap[key].name === name) {
          return key;
        }
      } else {
        if (cMap[key].parentId === parent && cMap[key].name === name) {
          return key;
        }
      }
    }
    return null;
  }

  function isCategoryExist(cMap, parent, name) {
    for (var key in cMap) {
      if (parent == undefined && cMap[key].parentId == undefined) {
        if (cMap[key].name === name) {
          return true;
        }
      }
      if (cMap[key].parentId) {
        if (cMap[key].parentId === parent && cMap[key].name === name) {
          return true;
        }
      }
    }
    return false;
  }
  async function onImport() {
    setDataTableTitle("Import Product");
    setColumns(getDefaultColumns());
    setLoading(true);
    setDisableLoading(true);
    setDisableImport(true);
    const input = document.getElementById("product_import_input");
    try {
      let rows = await readXlsxFile(input.files[0]);
      let colMap = validateColumns(rows);
      if (colMap) {
        let vendorRows = await readXlsxFile(input.files[0], { sheet: 2 });
        setVendorData(vendorRows);
        if (colMap) {
          importToDexie(rows, colMap, vendorRows);
        }
      }
    } catch (err) {
      console.log(err);
      setVendorData([]);
      setLoading(false);
    }
    setLoading(false);
    setDisableLoading(false);
    setDisableImport(false);
  }
  function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
  const colMapping = {
    vendor: { manadatory: true, options: ["vendor", "Supplier"] },
    code: { manadatory: false, options: ["DeCodept", "Item Code"] },
    dept: { manadatory: true, options: ["Dept", "Department", "Category1"] },
    subDept: {
      manadatory: false,
      options: ["Sub Dept", "Sub Department", "Category2", "SubDepartment"],
    },
    taxPer: {
      manadatory: false,
      default: "15",
      options: [
        "tax",
        "taxper",
        "tax percentage",
        "vat",
        "vatper",
        "vat percentage",
        "Tax",
      ],
    },
    name: {
      manadatory: true,
      options: ["Product", "Product Name", "Name", "Item", "Item Name"],
    },
    shortName: {
      manadatory: false,
      options: ["Short Name", "ShortName"],
    },
    localName: {
      manadatory: false,
      options: ["Local Name", "LocalName"],
    },
    description: {
      manadatory: false,
      options: ["description", "details"],
    },
    cost: {
      manadatory: true,
      options: ["cost"],
    },
    price: {
      manadatory: true,
      options: ["price", "Selling Price", " Retail Sale price", "RSP"],
    },
    barcode: {
      manadatory: true,
      options: ["barcode", "barcodes"],
    },
    deliUOM: {
      manadatory: false,
      options: ["deli UOM"],
    },
    unitType: {
      manadatory: false,
      default: "EACH",
      options: ["unit Type"],
    },
    factor: {
      manadatory: false,
      default: 1,
      options: ["Factor"],
    },
    productInfoField1: {
      manadatory: false,
      options: ["productInfoField1"],
    },
    productInfoField2: {
      manadatory: false,
      options: ["productInfoField2"],
    },
    productInfoField3: {
      manadatory: false,
      options: ["productInfoField4"],
    },
    productInfoField5: {
      manadatory: false,
      options: ["productInfoField5"],
    },
    productInfoField6: {
      manadatory: false,
      options: ["productInfoField6"],
    },
  };

  function validateColumns(rows) {
    let col = [];
    let colMap = {};
    let failureMap = [];
    let failed = false;
    for (var key in colMapping) {
      let col = colMapping[key];
      let colFound = false;
      let colIndex = -1;
      let ix = 0;
      for (let r of rows[0]) {
        if (r) {
          for (let opt of col.options) {
            if (r.toUpperCase() === opt.toUpperCase()) {
              colFound = true;
              colIndex = ix;
            }
          }
          ix++;
        }
      }
      if (colFound) {
        colMap[key] = colIndex;
      } else {
        if (col.manadatory) {
          failed = true;
          console.log("MANDATORY NOT FOUND", key);
          failureMap.push({
            key: key,
            message: "Manadatory Column " + key + " Not Found",
          });
        }
      }
    }
    if (failed) {
      let col = "";
      let comma = "";
      for (let err of failureMap) {
        col = comma + err.key;
        comma = ",";
      }
      setAlertMessage(
        "Not Able to Find mandatory columns (" + col + ") in Uploaded Excel "
      );
      setAlertFlag(true);
      return false;
    }
    return colMap;
  }
  function importToDexie(rows, colMap, vendorRows) {
    let count = 0;
    let rs = [];
    for (let row of rows) {
      if (count > 0) {
        let obj = {};
        for (let col in colMap) {
          obj[col] = row[colMap[col]];
        }
        let r = [];
        obj["id"] = uuidv4();

        r.push(
          obj.name,
          obj.code,
          obj.shortName,
          obj.localName,
          obj.vendor,
          obj.dept,
          obj.subDept,
          obj.taxPer,
          obj.deliUOM,
          obj.unitType,
          obj.factor,
          obj.cost,
          obj.price,
          obj.barcode,
          obj.productInfoField1,
          obj.productInfoField2,
          obj.productInfoField3,
          obj.productInfoField4,
          obj.productInfoField5,
          obj.productInfoField6,
          obj.id
        );
        rs.push(r);
      }
      count++;
    }
    setData(rs);
  }
  const handleCapture = ({ target }) => {
    if (target.files.length > 0) {
      setShowImport(true);
    } else {
      setShowImport(false);
    }
  };

  function openAlert(flag) {
    setAlertFlag(flag);
  }

  function onCloseImportSumamry() {
    setImporting(false);
  }
  /*
  async function fixBarcodeIssue() {
    let products = await db.product.toArray();
    let count = 0;
    let objects = [];
    let toSave = [];
    for (let p of products) {
      let saveFlag = false;
      for (let pr of p.productPricingBeanList) {
        let found = false;
        for (let bCode of pr.productBarcodeBeanList) {
          if (bCode.barcode.includes("+")) {
            console.log(bCode.barcode);
            found = true;
            count++;
          }
        }
        if (found) {
          let prd = getFromExcel(p.name, pr.unitType);
          if (prd) {
            let barcodeList = getBarcodes(prd[13]);
            pr.productBarcodeBeanList = barcodeList;
            saveFlag = true;
          }
        }
      }
      if (saveFlag) {
        toSave.push(p);
      }
    }
    console.log("Barcoides to Fix", toSave, count);
  }

  function getFromExcel(name, unitType) {
    let d = [...data];
    for (let a of d) {
      if (a[0] === name && a[9].toUpperCase() === unitType.toUpperCase()) {
        return a;
      }
    }
  }
*/
  const content = (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <Grid container>
            <Grid item>
              <Button variant="contained" component="label">
                Products
                <input
                  id="product_import_input"
                  type="file"
                  onChange={handleCapture}
                />
              </Button>
            </Grid>
            <Grid item>
              {showImport && (
                <Button
                  variant="contained"
                  component="label"
                  color="primary"
                  onClick={onImport}
                  disabled={disableLoading}
                >
                  {loading && <CircularProgress size={20} />} LOAD
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item x={12}>
          <Collapse in={alertFlag}>
            <Alert
              severity="error"
              action={
                <IconButton
                  aria-label="close"
                  color="error"
                  size="small"
                  onClick={() => {
                    openAlert(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {alertMessage}
            </Alert>
          </Collapse>
        </Grid>

        <Grid item xs={12} xl={12} xm={12}>
          <MUIDataTable
            title={dataTableTitle}
            data={data}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
      {importing && (
        <ImportProgress
          vendorProgress={vendorStat}
          vendorProgressMessage={
            <Grid container>
              <Grid item xs={12}>
                {vendorPer + "% Completed"}
              </Grid>
              <Grid item xs={12}>
                {successVendors}
              </Grid>
              <Grid item xs={12}>
                {failedVendors}
              </Grid>
            </Grid>
          }
          categoryProgress={catStat}
          categoryProgressMessage={
            <Grid container>
              <Grid item xs={12}>
                {catPer + "% Completed"}
              </Grid>
              <Grid item xs={12}>
                {successCat}
              </Grid>
              <Grid item xs={12}>
                {failedCat}
              </Grid>
            </Grid>
          }
          prodAnalysingMessage={
            <Grid container>
              <Grid item xs={12}>
                {prodAnalysingPer + "% Completed"}
              </Grid>
              <Grid item xs={12}>
                {analyseResult1}
              </Grid>
              <Grid item xs={12}>
                {analyseResult2}
              </Grid>
            </Grid>
          }
          prodAnalysingStats={prodAnalysingStat}
          productyProgressMessage={
            <Grid container>
              <Grid item xs={12}>
                {prodPer + "% Completed"}
              </Grid>
              <Grid item xs={12}>
                {successProd}
              </Grid>
              <Grid item xs={12}>
                {failedProd}
              </Grid>
            </Grid>
          }
          productProgress={prodStat}
          handleClose={onCloseImportSumamry}
        ></ImportProgress>
      )}
    </div>
  );
  return (
    <div>
      <PDialog
        content={content}
        title="Import Product"
        maxWidth={"lg"}
        fullWidth={true}
        open={true}
        onCloseWindow={onCloseWindow}
        onSave={onSave}
        mode={"create"}
        saveLabel={"IMPORT"}
        saveDisabled={disableImport}
        isSaveLoaderEnabled={importing}
      ></PDialog>
    </div>
  );
}
